import type { Task } from "@app/core";
import { create } from "zustand";

/** "cascade" = also apply to related tasks; "only" = just this one. */
export type RollupChoice = "cascade" | "only" | "cancel";

/** Which direction the cascade would run, for the popup wording. */
export type RollupDirection = "down" | "up";

export interface RollupPending {
  task: Task;
  done: boolean;
  direction: RollupDirection;
}

interface State {
  open: boolean;
  pending: RollupPending | null;
  resolveFn: ((choice: RollupChoice) => void) | null;
  ask: (pending: RollupPending) => Promise<RollupChoice>;
  resolve: (choice: RollupChoice) => void;
}

/** Promise-based popup for the "ask each time" subtask roll-up mode (mirrors
 *  {@link useRecurringConfirmStore}). */
export const useRollupConfirmStore = create<State>((set, get) => ({
  open: false,
  pending: null,
  resolveFn: null,
  ask: (pending) =>
    new Promise((resolve) => {
      set({ open: true, pending, resolveFn: resolve });
    }),
  resolve: (choice) => {
    const fn = get().resolveFn;
    set({ open: false, pending: null, resolveFn: null });
    fn?.(choice);
  },
}));
